module.exports = __webpack_public_path__ + "static/media/finish_survey_red.ba3a89e7.svg";